import {
    BreachServiceAndCatalogTypes,
    BreachSummaryTypes,
    IBreachServiceState,
    IBreachState,
    IBreachSummaryState,
    RECEIVE_BREACH_SUMMARY,
    RECEIVE_SERVICE_CATALOG,
    REQUEST_BREACH_SUMMARY,
    REQUEST_SERVICE_CATALOG,
} from "./types";

let breachSummaryResponse: IBreachSummaryState | any;
let breachServiceResponse: IBreachServiceState | any;

const initialState: IBreachState = {
    isLoading: false,
    breachSummaryData: breachSummaryResponse,
};
const breachServiceInitialState: IBreachServiceState = {
    isLoading: false,
    breachService: breachServiceResponse,
};

export function breachSummaryReducer(state = initialState, action: BreachSummaryTypes): IBreachState {
    if (state === undefined) {
        return initialState;
    }
    switch (action.type) {
        case REQUEST_BREACH_SUMMARY:
            return {
                isLoading: true,
                breachSummaryData: state.breachSummaryData,
            };
        case RECEIVE_BREACH_SUMMARY:
            return {
                isLoading: false,
                breachSummaryData: action.breachSummaryData,
            };
        default:
            return state;
    }
}

export function breachServiceAndCatalogReducer(state = breachServiceInitialState, action: BreachServiceAndCatalogTypes): IBreachServiceState {
    if (state === undefined) {
        return breachServiceInitialState;
    }
    switch (action.type) {
        case REQUEST_SERVICE_CATALOG:
            return {
                isLoading: true,
                breachService: state.breachService,
            };
        case RECEIVE_SERVICE_CATALOG:
            return {
                isLoading: false,
                breachService: action.breachService,
            };
        default:
            return state;
    }
}
